/* Vantia – interacciones propias del tema (sin librerías) */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.vt-reveal:not(.vt-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('vt-visible');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGaleria(root) {
    var main = root.querySelector('[data-vt-main]');
    var thumbs = root.querySelectorAll('[data-vt-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.dataset.src;
        main.srcset = b.dataset.srcset || '';
        main.alt = b.dataset.alt || main.alt;
        thumbs.forEach(function (x) { x.classList.remove('vt-on'); x.removeAttribute('aria-current'); });
        b.classList.add('vt-on');
        b.setAttribute('aria-current', 'true');
      });
    });
  }

  // Precio, tachado y botón siguen a la variante (pack) elegida
  function initVariantes(root) {
    var form = root.querySelector('[data-vt-form]');
    if (!form) return;
    var botones = root.querySelectorAll('[data-vt-add]');
    var precios = root.querySelectorAll('[data-vt-price]');
    var tachados = root.querySelectorAll('[data-vt-compare]');

    var datos = root.querySelector('[data-vt-variantes]');
    if (!datos) return;
    var variantes = JSON.parse(datos.textContent);
    var grupos = root.querySelectorAll('[data-vt-opcion]');
    var packs = root.querySelectorAll('[data-vt-pack]');
    var inputId = form.querySelector('input[name="id"]');
    var inputCantidad = form.querySelector('[data-vt-cantidad]');
    var main = root.querySelector('[data-vt-main]');

    function variante() {
      if (!grupos.length) return variantes[0];
      var vals = [];
      grupos.forEach(function (g) {
        var c = g.querySelector('input:checked');
        vals[+g.dataset.vtOpcion] = c ? c.value : null;
      });
      return variantes.filter(function (x) {
        return x.options.every(function (o, i) { return o === vals[i]; });
      })[0];
    }
    function pintar(cambiaOpcion) {
      var v = variante();
      var disponible = !!v && v.available;
      var elegido = v;
      // Un pack son varias unidades: su precio depende de la variante elegida (p. ej. el color)
      packs.forEach(function (card, i) {
        var radio = card.querySelector('input');
        var p = v && v.packs[i];
        if (!p) return;
        var ahorro = card.querySelector('[data-vt-pack-ahorro]');
        card.querySelector('[data-vt-pack-precio]').textContent = p.price;
        card.querySelector('[data-vt-pack-compare]').textContent = p.compare;
        ahorro.textContent = p.ahorro ? ahorro.dataset.prefijo + ' ' + p.ahorro : '';
        ahorro.hidden = !p.ahorro;
        if (radio.checked) {
          elegido = p;
          if (inputCantidad) inputCantidad.value = radio.value;
        }
      });
      if (v) {
        inputId.value = v.id;
        precios.forEach(function (el) { el.textContent = elegido.price; });
        tachados.forEach(function (el) { el.textContent = elegido.compare; });
        if (cambiaOpcion && v.imagen && main) { main.src = v.imagen; main.srcset = ''; }
      }
      botones.forEach(function (b) {
        b.disabled = !disponible;
        b.textContent = disponible ? b.dataset.textoAdd : b.dataset.textoAgotado;
      });
    }
    grupos.forEach(function (g) { g.addEventListener('change', function () { pintar(true); }); });
    packs.forEach(function (card) { card.addEventListener('change', function () { pintar(false); }); });
  }

  // "Entrega estimada: 20 de oct – 26 de oct" contando solo días laborables
  function initEntrega(root) {
    var el = root.querySelector('[data-vt-entrega]');
    if (!el) return;
    var min = parseInt(el.dataset.min, 10);
    var max = parseInt(el.dataset.max, 10);
    if (!min || !max || max < min) return;
    var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    function laborable(n) {
      var d = new Date(), k = 0;
      while (k < n) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() % 6) k++;
      }
      return d.getDate() + ' de ' + meses[d.getMonth()];
    }
    el.textContent = laborable(min) + ' – ' + laborable(max);
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-vt-sticky]');
    var cta = root.querySelector('[data-vt-form] [data-vt-add]');
    if (!bar || !cta || !('IntersectionObserver' in window)) return;
    document.body.classList.add('vt-con-sticky');
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('vt-on', !entries[0].isIntersecting);
    }).observe(cta);
  }

  // Antes y después: la barra es un control deslizante invisible que cubre la imagen
  function initComparador(root) {
    if (root.dataset.vtListo) return;
    root.dataset.vtListo = '1';
    var rango = root.querySelector('input[type="range"]');
    if (!rango) return;
    rango.addEventListener('input', function () {
      root.style.setProperty('--vt-pos', rango.value + '%');
    });
  }

  function initProducto(root) {
    if (root.dataset.vtListo) return;
    root.dataset.vtListo = '1';
    initGaleria(root);
    initVariantes(root);
    initEntrega(root);
    initSticky(root);
  }

  function init() {
    document.querySelectorAll('[data-vt-producto]').forEach(initProducto);
    document.querySelectorAll('[data-vt-comparador]').forEach(initComparador);
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // El editor de Shopify vuelve a pintar las secciones al cambiar ajustes
  document.addEventListener('shopify:section:load', init);
})();
